import { types } from 'mobx-state-tree';

export const EmailConfirmation = types.model('EmailConfirmation', {
    isTokenValid: types.boolean,
    email: types.maybeNull(types.string),
});

export default EmailConfirmation;
